export const creditCardKey = 'credit_card';
export const cashKey = 'cash';
export const chequeKey = 'cheque';
export const transferKey = 'transfer';

export const perHourKey = 'per_hour';
export const setPriceKey = 'set_price';
export const uponResultKey = 'upon_result';

export const paymentMeansCheckboxes: { [s: string]: string } = {
  [creditCardKey]: 'Carte de crédit',
  [cashKey]: 'Espèces',
  [chequeKey]: 'Chèque',
  [transferKey]: 'Virement',
};

export const billingCheckboxes: { [s: string]: string } = {
  [perHourKey]: 'Honoraire au temps passé',
  [setPriceKey]: 'Honoraire forfaitaire',
  [uponResultKey]: 'Honoraire au résultat',
};

export const feesDetails: { [s: string]: string } = {
  [perHourKey]:
    'Un taux horaire est convenu avec le client de sorte que la facturation varie selon le temps de travail consacré à chaque dossier',
  [setPriceKey]:
    'Un montant global et forfaitaire est convenu avec le client pour le traitement de l’intégralité du dossier.',
  [uponResultKey]:
    'Un complément de rémunération s’ajoute à l’honoraire au temps passé ou à l’honoraire forfaitaire. Il est calculé selon un pourcentage du gain, de l’économie ou de l’avantage obtenu. Ce complément d’honoraire est payable dès que le résultat est définitivement acquis.',
};

export function paymentMeansToString(array: Array<string>): string {
  return array.map(element => paymentMeansCheckboxes[element]).join(', ');
}

export function billingToString(
  billing: Array<string>,
  billingExtraInfo: string,
): string {
  const billingText = billing
    .map(element => billingCheckboxes[element])
    .join('\n');
  const space = billingText && billingExtraInfo ? '\n\n' : '';
  const extraInfo = billingExtraInfo
    ? `Complément d'informations :\n${billingExtraInfo}`
    : '';
  return `${billingText}${space}${extraInfo}`;
}

function preventNull(method: Function) {
  return (obj: boolean | null | undefined) => {
    if (obj === null || obj === undefined) {
      return null;
    }
    return method(obj);
  };
}

function rawAcceptedChoice(obj: boolean) {
  return obj === true ? 'Accepté' : 'Non accepté';
}

function rawPayingChoice(obj: boolean) {
  return obj === true ? 'Gratuit' : 'Payant';
}

function rawYesNoChoice(obj: boolean) {
  return obj === true ? 'Oui' : 'Non';
}

export const acceptedChoice = preventNull(rawAcceptedChoice);
export const payingChoice = preventNull(rawPayingChoice);
export const yesNoChoice = preventNull(rawYesNoChoice);

export function getFeesInfo(array: Array<string>): Object | null {
  if (!array || array.length === 0) {
    return null;
  }
  const obj: { [s: string]: { title: string; info: string } } = {};
  array.forEach(item => {
    obj[item] = {
      title: billingCheckboxes[item],
      info: feesDetails[item],
    };
  });
  return obj;
}
